import { render, staticRenderFns } from "./CreateOrUpdatePerson.vue?vue&type=template&id=2421013a"
import script from "./CreateOrUpdatePerson.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdatePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports